import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ITutor } from '@wot/typings';
import tutorsApi from '../../api/tutors';
import { CAUTION } from '../../assets/images';
import { Button } from '@wot/components';
import { LOADING } from '../../assets/animated';
import TutorCard from '../TutorCard';
import Carousels from '../Carousels';
export default function   Findtutors() {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [tutorsList, setTutorsList] = useState<ITutor[]>([]);
    const [currentPage/*, setCurrentPage*/] = useState<number>(1);
    const [resultsPerPage /* , setResultsPerPage */] = useState<number>(8);
    useEffect(()=>{
         let filter = Object.assign(
            {},     
            { page: currentPage },
        { resultsPerPage },
        // location.state?.categoryType && { category: location.state.categoryType },
        // location.state.name && { categoryName: [location.state.name] }        
         );
         setLoading(true)
         tutorsApi.getFilteredTutors(filter)
         .then((data)=>{
            setTutorsList(data.results.filter((s: any) => s.status === "active"));
            setLoading(false)
         }).catch(() => setLoading(false));
    },[location.state])
  return (
    <div className='bg-gray-50 py-10'>
      {/* Findtutors component */}
      {loading ? (
          <div className="min-h-[512px] flex items-center justify-center">
            <img src={LOADING} className="w-14 h-14" />
          </div>):(<>            
     { tutorsList.length > 0 ? (<div className='container mx-auto '>
        <h2 className='h1 text-center max-w-2xl mx-auto'>Learn From the best Online Tutors</h2>
     
       
        <div className="md:grid 2xl:grid-cols-4 lg:grid-cols-3  hidden sm:grid-cols-2 grid-cols-1 gap-4 py-10">
                  {tutorsList.map((item: any, index: any) => (
                    <TutorCard item={item} key={index} />
                  ))}
                  
                </div>
                <div className='md:hidden my-7'>
                <Carousels>
                {tutorsList.map((item: any, index: any) => (
                    <TutorCard item={item} key={index} />
                  ))}
                </Carousels>
                </div>
        </div> ):(
                 <>
                 <div className="flex flex-col gap-5 items-center py-10">
                   <img src={CAUTION} alt="No tutors found" className="rounded-full" />
                   <div className="flex flex-col items-center w-full gap-2">
                     <span className="text-2xl font-medium">Oops,</span>
                     <span className="w-full text-lg font-normal text-center">No trainers found.</span>
                   </div>
                   <div className="max-w-[200px]">
                     <Link to="/post-requirement">
                       <Button text="Post a Requirement" size="lg" />
                     </Link>
                   </div>
                 </div>
               </>
        )
        
    }

     <div className='flex items-center justify-center'>
         <Button text='view more' onClick={()=>navigate('/find-tutor')} className='!px-12 !text-lg !bg-primary !border-primary' size='lg'/>
         </div>    
         </>)} 
   
    </div>
  );
}